var Saga;
(function (Saga) {
    Saga["DynamoAdapterWriteError"] = "PBSAGDynamoAdapterWriteError";
    Saga["DynamoAdapterReadError"] = "PBSAGDynamoAdapterReadError";
    Saga["RestAdapterRequestException"] = "PBSAGRestAdapterRequestException";
    Saga["RestAdapterInvalidEndpoint"] = "PBSAGRestAdapterInvalidEndpoint";
    Saga["RestAdapterNoEndpointSet"] = "PBSAGRestAdapterNoEndpointSet";
    Saga["SagaLogInvalidEntry"] = "PBSAGSagaLogInvalidEntry";
    Saga["SagaLogInvalidState"] = "PBSAGSagaLogInvalidState";
    Saga["RedemptionFlowInvalidSagaStatus"] = "PBSAGRedemptionFlowInvalidSagaStatus";
    Saga["SagaNotFound"] = "PBSAGSagaNotFound";
    Saga["SagaNotFoundForPayment"] = "PBSAGSagaNotFoundForPayment";
    Saga["SagaForbiddenNotOwner"] = "PBSAGSagaForbiddenNotOwner";
    Saga["TokenMissing"] = "PBSAGTokenMissing";
    Saga["PaymentNotRequired"] = "PBSAGPaymentNotRequired";
    Saga["PaymentCannotCompleteSagaAborted"] = "PBSAGPaymentCannotCompleteSagaAborted";
    Saga["Payment3DSInputRequired"] = "PBSAGPayment3DSInputRequired";
    Saga["StockIssue"] = "PBSAGStockIssue";
    Saga["InvalidJsonRequest"] = "PBSAGInvalidJsonRequest";
    Saga["InvalidRequesMissingOrUnexpectedFields"] = "PBSAGInvalidRequesMissingOrUnexpectedFields";
    Saga["InvalidRequestEmail"] = "PBSAGInvalidRequestEmail";
    Saga["StepCannotStartSagaAborted"] = "PBSAGStepCannotStartSagaAborted";
    Saga["StepNotRequired"] = "PBSAGStepNotRequired";
    Saga["StepPreviousStepNotCompleted"] = "PBSAGStepPreviousStepNotCompleted";
    Saga["StepStepAlreadyCompleted"] = "PBSAGStepStepAlreadyCompleted";
    Saga["PaymentAlreadyStarted"] = "PBSAGPaymentAlreadyStarted";
    Saga["PaymentSuspectedAsRefused"] = "PBSAGPaymentSuspectedAsRefused";
})(Saga || (Saga = {}));
export default Saga;
